import { ChatRoom } from '@dinosband/bv-main-schema/dist/types'
import { readChatRoomBrief } from '@dinosband/bv-main-client'
import { DataCenter_ProxyType } from '../abstract'
import { CHAT_ROOM_ADDED } from './const'

export class SupplementChatRooms extends DataCenter_ProxyType<number, ChatRoom> {

  chatRoomPool: Record<number, ChatRoom> = {}

  cleanup () {
    super.cleanup()
    this.chatRoomPool = {}
  }

  get chatRooms () {
    return Object.values(this.chatRoomPool)
  }

  protected async query (key: number): Promise<ChatRoom | undefined> {
    // console.error('[SupplementChatRooms]', 'query', key)
    const chatRoom = await readChatRoomBrief(await this.mainStore.apollo.getClient(), key)
    if (chatRoom) {
      this.pubsub.publish(CHAT_ROOM_ADDED, {
        channelId: -1, // means supplement chat-room
        chatRooms: [chatRoom],
      })
    }
    return chatRoom
  }
}
